module.exports = __webpack_public_path__ + "static/img/title.843d19d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mo/title.png
// module id = shON
// module chunks = 0